import styled from 'styled-components';
export const PORTAL_Z_INDEX = 100;
export const PortalNodeContainer = styled.div `
  position: relative;
  z-index: ${PORTAL_Z_INDEX};
`;
